module.exports = __webpack_public_path__ + "img/options-exam.5390e6be.png";